import {
  FormControl,
  FormLabel,
  HStack,
  Icon,
  Input,
  Menu,
  MenuItem,
  MenuList,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Text,
} from "@chakra-ui/react";
import { FaChevronDown, FaFilter } from "react-icons/fa";
import { useState } from "react";
import { CURRENCIES } from "../../balanceSheetConstants";
import { getEndOfMonth } from "../../balanceSheetUtils";
import { ReportActionButton } from "../../Shared/Components/ReportActionButton";
import { ReportFilterButton } from "../../Shared/Components/ReportFilterButton";
import { ReportMenuButton } from "../../Shared/Components/ReportMenuButton";
import { reportToolbarStyles } from "../../Shared/Styles/reportToolbarStyles";

export const AnalyticalLayersFilters = ({
  currentCurrency,
  initialDate,
  onApplyFilters,
  onCurrencyChange,
  texts,
}) => {
  const [selectedDate, setSelectedDate] = useState(initialDate.substring(0, 7));
  return (
    <HStack spacing={2}>
      <Menu>
        <ReportMenuButton>
          <HStack spacing={2}>
            <Text>
              {texts.reports?.figuresIn || "Figures in"}{" "}
              {CURRENCIES.find((currency) => currency.code === currentCurrency)
                ?.label || currentCurrency}
            </Text>
            <Icon as={FaChevronDown} />
          </HStack>
        </ReportMenuButton>
        <MenuList {...reportToolbarStyles.menuList}>
          {CURRENCIES.map((currency) => (
            <MenuItem
              key={currency.code}
              onClick={() => onCurrencyChange(currency.code)}
            >
              {currency.label}
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
      <Popover>
        <PopoverTrigger>
          <ReportFilterButton leftIcon={<Icon as={FaFilter} />}>
            {texts.reports?.filter || "Filter"}
          </ReportFilterButton>
        </PopoverTrigger>
        <PopoverContent {...reportToolbarStyles.popoverContent} w="300px">
          <PopoverArrow />
          <PopoverHeader fontWeight="bold">
            {texts.reports?.filter || "Filter"}
          </PopoverHeader>
          <PopoverBody>
            <FormControl>
              <FormLabel fontSize="sm">
                {texts.reports?.asAtEndOf || "As at end of (Month/Year)"}
              </FormLabel>
              <Input
                type="month"
                value={selectedDate}
                onChange={(event) => setSelectedDate(event.target.value)}
                size="sm"
              />
            </FormControl>
            <ReportActionButton
              variant="primary"
              mt={4}
              onClick={() =>
                onApplyFilters({ date: getEndOfMonth(selectedDate) })
              }
            >
              {texts.reports?.apply || "Apply"}
            </ReportActionButton>
          </PopoverBody>
        </PopoverContent>
      </Popover>
    </HStack>
  );
};
